/* ========================== */
/* ========= import ========= */
/* ========================== */
/* ====== React ====== */
import React from "react"
/* ====== CSS ====== */
import styled from 'styled-components';
/* ====== Component Js/Jsx ====== */
import { assets } from '03CommonApiParts/Configuration';
import { InputErrorMessage } from '02CommonUiParts/TableParts/InputErrorMessage';

/* ========================== */
/* ========= Styles ========= */
/* ========================== */

/* ====== Styled Components ====== */
const SdivCheckGroup = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    /* width: fit-content; */
    /* margin: 0 auto; */

`;
const SlabelCheck = styled.label`//ラジオボタンのラベル
    /* margin-right: 10px; */
    width: fit-content;
    line-height:18px;
    white-space: nowrap;
    cursor: pointer;
    pointer-events: ${(props) => props?.eventNone && 'none'};
    /* background-color:red; */
`;
const SinputCheck = styled.input`
    cursor: pointer;
    margin: 1px 2px;
`;

const SdivCheckBox = styled.div`
    /* margin-left:6px; */
    border:2px solid red;
    border-radius:2px;
    width: 10px;
    height: 10px;
    display:flex;
    background-color:${props=>props.check ? 'red' : 'white'};
`;
const SdivCheckLabelBox = styled.div`
    /* margin-left:6px; */
    border:2px solid #D9D9D9;
    border-radius:2px;
    width: 10px;
    height: 10px;
    display:flex;
    background-color:${props=>props.check ? '#D9D9D9' : 'white'};
`;

const SdivCheckMark = styled.div`
    content: '';
    position:relative;
    top:1px;
    width: 7px;
    height: 3px;
    border-left:  ${props=>props.check ? '2.5px solid white' : 'none'};
    border-bottom: ${props=>props.check ? '2.5px solid white' : 'none'};
    transform: rotate(-45deg);
`;
/* How To Use 
       <TableCheck
            id={items.name}
            label={items.title}
            defaultChecked={dataRow[items.name]}
            register= {register(`${payload}.${items.name}`,
            {
                required: items.required?CFArrayFount(inputCheckMaster.list,'value','required').label:'',
            })}
            // readOnly={items.readOnly}
            />
*/

/*==================*/
/*=====  Main  =====*/
/*==================*/
/*------ エラー右に表示 ------*/
export const TableCheck = (props) => {
    /* --------------------------- */
    /* --------- valiables -------- */
    /* --------------------------- */
    const { id, register, label, defaultChecked, disabled, value, errorMessage, onClick, scale, isDirty, labelId } = props;
    let check  = defaultChecked === '未入力' ? false : defaultChecked;
    /*--------------------------*/
    /*------ Start Render ------*/
    /*--------------------------*/
    return (
        <SdivCheckGroup>
            <SlabelCheck id={labelId} className='baseText' style={{fontSize: assets().size.baseText}} htmlfor={id}>
                <label style={{backgroundColor: isDirty ? assets().color.yellow : '' }}>
                <SinputCheck
                    {...register}
                    defaultChecked={check}
                    disabled={disabled}
                    value={value}
                    style={{transform: `scale(${scale})`}}
                    // readOnly={readOnly}
                    // onChange={onChange}
                    type='checkbox'
                    onClick={onClick}
                />
                </label>
                {label ? label : ''}
            </SlabelCheck>
            {errorMessage !== undefined ? <InputErrorMessage errorMessage={errorMessage} /> : ''}
        </SdivCheckGroup>
    );
};

/* 確認用のチェックボックス */
export const TableCnfCheck = (props) =>{
    const { defaultChecked } = props;
    let check  = defaultChecked === '未入力' ? false : (defaultChecked === 'true'?  true : (defaultChecked === 'false' ? false : defaultChecked));

    return(
        <SdivCheckGroup>
            <SdivCheckBox check={check}>
                <SdivCheckMark check={check}/>
            </SdivCheckBox>
        </SdivCheckGroup>
    )
}

/* registarなし確認用のチェックボックス */
export const TableCnfCheck2 = (props) =>{
    const { defaultChecked } = props;
    let check  = defaultChecked === '未入力' ? false : (defaultChecked === 'true'?  true : (defaultChecked === 'false' ? false : defaultChecked));

    return(
        <SdivCheckGroup>
            <SdivCheckLabelBox check={check}>
                <SdivCheckMark check={check}/>
            </SdivCheckLabelBox>
        </SdivCheckGroup>
    )
}